'use strict';

import './modules/polyfill-foreach.js';
import './modules/keyboard-mouse.js';
import './modules/search-toggle.js';
